import React, { useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { usePortal } from '../contexts/PortalContext';
import { brand } from '../data/projects';

/**
 * The only thing between a client and their project: a name, so their comments
 * and approvals can be attributed. No account, no password, no email.
 */
export function Login() {
  const {
    signIn,
    activeProject
  } = usePortal();
  const [name, setName] = useState('');

  /* Built from whatever the project actually has, so an unresolved project
     never leaves a lone separator sitting under the heading. */
  const projectLine = [activeProject.client, activeProject.name].map(part => part.trim().toUpperCase()).filter(Boolean).join(' · ');
  return <div className="relative flex min-h-screen w-full items-center justify-center bg-ink px-6 py-20 text-paper" data-id="element-2242" data-mp="2ylqxxxfz5t8e">
      {/* Light grazing a matte black wall, drawn rather than photographed so
          the surface stays perfectly clean. */}
      <div aria-hidden className="pointer-events-none absolute inset-0" style={{
      background: 'radial-gradient(120% 90% at 18% 8%, rgba(255,255,255,0.16) 0%, rgba(255,255,255,0.06) 34%, rgba(255,255,255,0) 68%)'
    }} data-id="element-2243" data-mp="2rh27x0figj7q" />

      <div className="relative w-full max-w-xl" data-id="element-2244" data-mp="318yi39uvfzsb">
        <img src={brand.lockup} alt="Portal Productions" className="h-8 w-auto brightness-0 invert sm:h-10" data-id="element-2245" data-mp="2wfvlesussa7w" />

        <h1 className="mt-20 font-display text-4xl leading-[0.98] tracking-tight sm:text-6xl" data-id="element-2246" data-mp="3a9my2a3tsa7u">
          Welcome to
          <br data-id="element-2247" data-mp="3k5pxv9b7fwrm" />
          your project.
        </h1>

        {projectLine && <p className="label mt-8 text-paper/40" data-id="element-2248" data-mp="3k4yecwuvtphp">{projectLine}</p>}

        <form onSubmit={event => {
        event.preventDefault();
        /* signIn trims internally too, but trimming here keeps the
           submitted value in step with the trimmed check that enables
           the button, rather than relying on a second layer to catch it. */
        signIn(name.trim());
      }} className="mt-12 max-w-xs" data-id="element-2249" data-mp="3f6d92j0rwfme">
          <label className="block" data-id="element-2250" data-mp="2eje6egtccv1e">
            <span className="label block text-paper/50" data-id="element-2251" data-mp="2ekfhglacxhj4">Your Name</span>
            <input value={name} onChange={event => setName(event.target.value)} autoFocus autoComplete="name" className="mt-4 w-full border-b border-paper/30 bg-transparent pb-3 font-display text-3xl text-paper focus:border-paper focus:outline-none sm:text-4xl" data-id="element-2252" data-mp="2jgo5ko6j8l2f" />
          </label>

          <button type="submit" disabled={!name.trim()} className="label group mt-7 flex w-full items-center justify-between gap-6 border border-paper px-8 py-5 text-paper transition-colors duration-150 ease-out hover:bg-paper hover:text-ink disabled:border-paper/25 disabled:text-paper/30 disabled:hover:bg-transparent disabled:hover:text-paper/30" data-id="element-2253" data-mp="327f9ha7r3j9f">
            Continue
            <ArrowRightIcon className="h-3.5 w-3.5 transition-transform duration-150 ease-out group-hover:translate-x-1" strokeWidth={1.25} data-id="element-2254" data-mp="15iw0dwysb2jz" />
          </button>

          <p className="label-sm mt-6 leading-relaxed text-paper/30" data-id="element-2255" data-mp="vkpyvggw3yfn">
            No account needed. We&rsquo;ll remember your name on this device.
          </p>
        </form>

        <p className="mt-20 font-display text-base italic text-paper/35" data-id="element-2256" data-mp="1o8vmqc38q3jp">Step through the portal</p>
      </div>
    </div>;
}